// Redux Store for Home

// Constants
import * as reducers from '../../common/storeConstants';
import * as expReducers from '../../../experimentations/constants/StoreConstants';

// Reducers
import topicTree from '../../components/topicTree/TopicTree-Reducer';
import personalizedSection from '../../components/personalizedSection/PersonalizedSection-Reducers';
import recommendedSolutions from '../../components/recommendedArticles/RecommendedArticles-Reducer';
import nnaWidget from '../../components/NNAWidget/NNAWidget-Reducer';
import trackers from '../../components/trackers/Trackers-Reducer';
import search from '../../components/searchBar/SearchBar-Reducer';
import topContactReasons from '../../components/searchBar/SearchBar-topContactReducer';
import authConfirmationPrompt from '../../components/authConfirmationPrompt/AuthConfirmationPrompt-Reducer';
import transactionList from '../../../experimentations/reducers/TransactionList';

export default {
  [reducers.TOPIC_TREE]: topicTree,
  [reducers.PERSONALIZED_FEED]: personalizedSection,
  [reducers.RECOMMENDED_SOLUTIONS]: recommendedSolutions,
  [reducers.NNA]: nnaWidget,
  [reducers.TRACKERS]: trackers,
  [reducers.SEARCH]: search,
  [reducers.SEARCH_TOP_CONTACT_REASONS]: topContactReasons,
  [reducers.AUTH_CONFIRMATION_PROMPT]: authConfirmationPrompt,
  [expReducers.TRANSACTION_LIST]: transactionList,
};
